/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm} from "@insticator/insticator-ui";
import sectiongroup from "../../../../../../material/expandablesection/sectiongroup/sectiongroup";


/* ++++++++++ --------------- SENTIMENT ADVANCED SETTINGS - ADVANCED CONFIGS : STYLES --------------- ++++++++++ */

export default {
    revenueMetricsSettings: {
        padding: pxToEm(25),
        paddingTop: pxToEm(30),
        paddingBottom: pxToEm(20),
        '& .sectiongroup': {
            display: "flex",
            marginTop: 0,
            marginBottom: pxToEm(20),
            '&.secondary': {
                marginLeft: pxToEm(150),
              }
        },
        '& .switch': {
            marginRight: pxToEm(16)
        }
    }
};
